export const EDIT_GROUP_START = 'EDIT_GROUP_START';
export const EDIT_GROUP_SUCCESS = 'EDIT_GROUP_SUCCESS';
export const EDIT_GROUP_FAILURE = 'EDIT_GROUP_FAILURE';
export const DELETE_GROUP_START = 'DELETE_GROUP_START';
export const DELETE_GROUP_SUCCESS = 'DELETE_GROUP_SUCCESS';
export const DELETE_GROUP_FAILURE = 'DELETE_GROUP_FAILURE';
export const ADD_GROUP_TO_PROJECT_START = 'ADD_GROUP_TO_PROJECT_START';
export const ADD_GROUP_TO_PROJECT_SUCCESS = 'ADD_GROUP_TO_PROJECT_SUCCESS';
export const ADD_GROUP_TO_PROJECT_FAILURE = 'ADD_GROUP_TO_PROJECT_FAILURE';
